import { FullPageLoader } from 'components/loader'
import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { usePortalAuth } from 'utils/portalAuth'

import { readReturnTo, rememberReturnTo, safeReturnTo } from './returnTo'

/** Explicit legacy entry keeps Auth0 and Google available during coexistence. */
export function LegacyAuth0Entry() {
  const { login, selectProvider, isLoading, error, isAuthenticated, provider } =
    usePortalAuth()
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const started = useRef(false)
  const [redirectError, setRedirectError] = useState(false)
  const destination = safeReturnTo(params.get('returnTo') ?? readReturnTo())

  useEffect(() => {
    if (provider !== 'auth0') {
      selectProvider('auth0')
      return
    }
    if (isLoading || error || started.current) return
    if (isAuthenticated) {
      navigate(destination, { replace: true })
      return
    }
    started.current = true
    rememberReturnTo(destination)
    void login({
      action: 'login',
      appState: { redirectUrl: destination },
    }).catch(() => setRedirectError(true))
  }, [
    destination,
    error,
    isAuthenticated,
    isLoading,
    login,
    navigate,
    provider,
    selectProvider,
  ])

  if (provider === 'auth0' && (error || redirectError)) {
    return (
      <div className="mx-auto max-w-md p-8" role="alert">
        <p>Auth0 login could not be completed. Please try again.</p>
        <a href="/login">Return to login</a>
      </div>
    )
  }
  return <FullPageLoader />
}
